import { isDevEnv } from '@config/environment'
import { StrictMode, useEffect } from 'react'
import { RouterProvider } from 'react-router'
import { SpriteLoader, TooltipProvider } from 'shared-ui/components'
import { isNonNil } from 'utils'

import AppProvider from './contexts/AppProvider'
import { router } from './routes'

const App: React.FC = () => {
  useEffect(() => {
    const favicon = document.getElementById('favicon') as HTMLLinkElement

    if (isNonNil(favicon)) {
      const faviconPath = isDevEnv() ? '/bananorama-favicon.png' : '/panorama-favicon.png'

      favicon.href = faviconPath
    }
  }, [])

  return (
    <div className="pan-body flex min-h-dvh flex-col bg-gray-50 text-gray-900 accent-green-400 selection:bg-green-400 selection:text-white">
      <StrictMode>
        <AppProvider>
          <TooltipProvider>
            <SpriteLoader />
            <RouterProvider router={router} />
          </TooltipProvider>
        </AppProvider>
      </StrictMode>
    </div>
  )
}

export default App
